module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAP1BMVEVHcEz///////////////////////////////////////////////////////////////////////////////9KjZoYAAAAFHRSTlMA97DvcOp1HwsQnEqElcswXFKjOiCFEqsAAAD3SURBVCjPhVNJAoMgDGQX6orO/9/aEBXBYs0JMtkzEeIUH8fJAnYae/EjYdDIYodQowv5SWX6beudkmQQC9B/SGF8/hoyHi9UAZ8qXFgBdX7I19xrMeRx5G2gjC8cSJ92JM7l5wqdEg6wOW8HdDm/xUB16SJ0CVN47UWE9G3YS0QqW4k2LBQ1P5Vl17DBJCT2DXRJNmDjB6t6aAHM3BEq4f5m4ITNA6yP4CEJKWZ+5OAvpb009jyWkMbyPFSXhvqykrTQ9aqmXOju1qaDO+jQJpPDRRKi4vpMRfa3LhsEVxE5n4GjM4j7GSz3I7J/jog3QCcoZX2CX29BE10mWFl2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/jxcjh.png
// module id = e13z
// module chunks = 1